/* assets/video-patcher.js — neuter any autoplaying <video> on load */
(function () {
  function neuter(video) {
    if (!video || video.dataset.patched === "1") return;
    video.dataset.patched = "1";

    // Capture sources
    var saved = [];
    var srcAttr = video.getAttribute("src");
    if (srcAttr) saved.push({ src: srcAttr, type: video.getAttribute("type") || "" });
    video.querySelectorAll("source").forEach(function (s) {
      saved.push({ src: s.getAttribute("src"), type: s.getAttribute("type") || "" });
    });

    // Stop network and autoplay
    video.removeAttribute("src");
    video.querySelectorAll("source").forEach(function (s) { s.remove(); });
    video.autoplay = false; video.removeAttribute("autoplay");
    video.preload = "none"; video.setAttribute("preload","none");
    try { video.pause(); } catch(e){}

    // Build a lightweight click-to-play wrapper
    var wrap = document.createElement("div");
    wrap.className = "deferred-video";
    var posterURL = video.getAttribute("poster") || (saved[0] ? saved[0].src : "");
    var poster = document.createElement("img");
    poster.className = "deferred-video__poster";
    if (posterURL) poster.src = posterURL;

    var btn = document.createElement("button");
    btn.className = "deferred-video__play";
    btn.type = "button";
    btn.textContent = "▶︎";

    var mount = document.createElement("div");
    mount.className = "deferred-video__mount";

    var parent = video.parentNode;
    if (!parent) return;
    parent.replaceChild(wrap, video);
    wrap.appendChild(poster);
    wrap.appendChild(btn);
    wrap.appendChild(mount);

    btn.addEventListener("click", function () {
      var v = document.createElement("video");
      v.classList.add("defer-exempt");
      v.preload = "none"; v.muted = true; v.playsInline = true; v.setAttribute("playsinline","");
      saved.forEach(function (s) {
        if (!s.src) return;
        var so = document.createElement("source");
        so.src = s.src; if (s.type) so.type = s.type;
        v.appendChild(so);
      });
      if (poster) poster.style.display = "none";
      btn.style.display = "none";
      mount.appendChild(v);
      v.play().catch(function(){});
    });
  }

  function scan() {
    document.querySelectorAll("video[autoplay], video[preload='auto']").forEach(neuter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
